<template>
  <!-- 这里更改成你的页面的class名 -->
  <div class="goback">
    <van-nav-bar left-text=""
                 @click-left="onClickLeft"
                 left-arrow>
      <template #title>
        {{name}}
      </template>
    </van-nav-bar>
  </div>
</template>

<script>
export default {
  props: ["name"],
  data () {
    return {}
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onClickRight () {
      this.$router.push("/center")
    }
  }
}
</script>

<style lang="less" scoped>
@deep: ~">>>";
@{deep}.van-nav-bar {
  height: 1.04rem;
  line-height: 1.04rem;
}
@{deep}.van-icon {
  font-size: 0.4rem;
}
@{deep}.van-nav-bar__title {
  font-size: 0.3rem;
  font-weight: bold;
  color: #333;
}
@{deep}.van-nav-bar__right {
  display: flex;
  align-items: center;
}
@{deep}.van-nav-bar .van-icon {
  color: #333;
}
@{deep}.van-hairline--bottom::after {
  border-bottom-width: 0.02rem;
  color: #E9E9E9;
}
span {
  font-size: 0.4rem;
}
</style>


// WEBPACK FOOTER //
// src/common/back.vue